import { useState } from 'react';
import { Plus } from 'lucide-react';

const faqs = [
    {
        q: "Czy wycena jest płatna i do czegoś zobowiązuje?",
        a: "Całkowicie nie. Przyjazd, doradztwo materiałowe i przygotowanie kosztorysu są u nas w 100% darmowe. Zależy nam, abyś miał pełny obraz sytuacji przed podjęciem decyzji."
    },
    {
        q: "Jak długo trwa standardowa wymiana papy na dachu płaskim?",
        a: "Krycie papą termozgrzewalną wykonujemy najczęściej w ciągu 3-7 dni, w zależności od powierzchni, stopnia skomplikowania dachu i pogody. Harmonogram prac ustalamy z góry."
    },
    {
        q: "Czy pomagacie w zamówieniu i doborze odpowiednich materiałów (styropian, tynk)?",
        a: "Tak, odciążamy inwestora w 100%. Posiadamy wysokie rabaty w hurtowniach budowlanych. Możesz również dostarczyć materiał samodzielnie – my zajmiemy się profesjonalnym wykonawstwem."
    },
    {
        q: "Czy udzielacie gwarancji na swoją pracę?",
        a: "Oczywiście. Na każdą usługę podpisujemy pisemną umowę. Udzielamy gwarancji na solidność i trwałość wykonania. Bierzemy pełną odpowiedzialność za końcowy efekt."
    }
];

export default function FAQ() {
    const [open, setOpen] = useState(0);

    return (
        <section className="bg-primary py-24 px-6 md:px-16 text-dark z-10 relative">
            <div className="max-w-4xl mx-auto">
                <div className="mb-16 text-center">
                    <span className="font-mono text-sm tracking-widest uppercase text-accent font-bold block mb-4">
                        Masz Wątpliwości?
                    </span>
                    <h2 className="text-4xl md:text-5xl font-heading font-bold uppercase tracking-tight text-dark">
                        Najczęściej Zadawane Pytania
                    </h2>
                </div>

                <div className="flex flex-col gap-4">
                    {faqs.map((faq, i) => {
                        const isOpen = open === i;
                        return (
                            <div
                                key={i}
                                className={`bg-background rounded-3xl overflow-hidden transition-all duration-500 border border-dark/5 ${isOpen ? 'shadow-[0_8px_30px_rgba(0,0,0,0.06)] scale-[1.01]' : 'shadow-sm hover:shadow-md hover:border-dark/10'}`}
                            >
                                <button
                                    onClick={() => setOpen(isOpen ? -1 : i)}
                                    className="w-full text-left py-6 px-6 md:px-8 flex items-center justify-between focus:outline-none group"
                                >
                                    <span className={`font-heading font-bold text-lg md:text-xl pr-8 transition-colors duration-300 ${isOpen ? 'text-accent' : 'text-dark group-hover:text-accent'}`}>
                                        {faq.q}
                                    </span>
                                    <div className={`shrink-0 w-10 h-10 rounded-full flex items-center justify-center transition-all duration-500 ${isOpen ? 'bg-accent text-background rotate-45' : 'bg-dark/5 text-dark group-hover:bg-dark/10'}`}>
                                        <Plus size={20} strokeWidth={2.5} />
                                    </div>
                                </button>

                                <div
                                    className={`px-6 md:px-8 overflow-hidden transition-all duration-500 ease-in-out ${isOpen ? 'max-h-[500px] opacity-100 pb-6' : 'max-h-0 opacity-0 pb-0'}`}
                                >
                                    <p className="font-body text-base md:text-lg text-dark/70 leading-relaxed border-t border-dark/10 pt-4 mt-2">
                                        {faq.a}
                                    </p>
                                </div>
                            </div>
                        )
                    })}
                </div>
            </div>
        </section>
    );
}
